import React from 'react';
import { Container, Card } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';
import { useLocalization } from '../context/LocalizationContext';

export const UserProfile: React.FC = () => {
  const { user } = useAuth();
  const { t } = useLocalization();

  return (
    <Container className="py-5">
      <h1 className="mb-4">{t('profileTitle')}</h1>

      <Card>
        <Card.Header>{t('profileTitle')}</Card.Header>
        <Card.Body>
          <div className="mb-4">
            <div className="fw-semibold">{user?.firstName} {user?.lastName}</div>
            <div className="text-muted">{user?.email}</div>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default UserProfile;
